module.exports = __webpack_public_path__ + "media/images/emblems/Isenthal-coat_of_arms-fcc1f13f8d284593d09719cc90cf1451.svg";